export const LANGUAGES = ['en', 'fr', 'hi'];